"use client";

import { c as _c } from "react/compiler-runtime";
import * as stylex from "@stylexjs/stylex";
import * as base58 from "bytestring/base58";
import * as React from "react";
import { Exhibit } from "timvir/blocks";
import { useBlock } from "timvir/core";
import { layoutStyles } from "../../core/layout";
import { cx } from "../../internal/cx";
import { Context } from "./context";
/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
export function Arbitrary(props) {
  const $ = _c(55);
  const block = useBlock(props);
  let ExhibitProps;
  let children;
  let className;
  let rest;
  if ($[0] !== block.props) {
    ({
      ExhibitProps,
      className,
      children,
      ...rest
    } = block.props);
    $[0] = block.props;
    $[1] = ExhibitProps;
    $[2] = children;
    $[3] = className;
    $[4] = rest;
  } else {
    ExhibitProps = $[1];
    children = $[2];
    className = $[3];
    rest = $[4];
  }
  let t0;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      settled: false,
      seed: 0
    };
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const [value, setValue] = React.useState(t0);
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setValue({
        settled: true,
        seed: crypto.getRandomValues(new Uint32Array(1))[0]
      });
    };
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const refreshSeed = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [refreshSeed];
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  React.useEffect(refreshSeed, t2);
  let t3;
  let t4;
  if ($[8] !== block.bus || $[9] !== props.id || $[10] !== value.seed) {
    t3 = () => {
      if (props.id) {
        block.bus.next({
          type: "SIGNAL",
          path: `/dev/timvir/block/${props.id}`,
          interface: "dev.timvir.block.Arbitrary",
          member: "seed",
          body: value.seed
        });
      }
    };
    t4 = [props.id, block.bus, value.seed];
    $[8] = block.bus;
    $[9] = props.id;
    $[10] = value.seed;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  React.useEffect(t3, t4);
  let T0;
  let T1;
  let rootStyleProps;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[13] !== className || $[14] !== rest || $[15] !== value) {
    rootStyleProps = stylex.props(layoutStyles.block, styles.root);
    T1 = Context;
    let t10;
    if ($[24] !== value.seed) {
      t10 = {
        seed: value.seed
      };
      $[24] = value.seed;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    t9 = t10;
    T0 = Root;
    t5 = true;
    t6 = rest;
    t7 = rootStyleProps;
    t8 = cx(!value.settled && "timvir-unsettled", rootStyleProps.className, className);
    $[13] = className;
    $[14] = rest;
    $[15] = value;
    $[16] = T0;
    $[17] = T1;
    $[18] = rootStyleProps;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    T0 = $[16];
    T1 = $[17];
    rootStyleProps = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  let t10;
  if ($[26] !== rest.style || $[27] !== rootStyleProps.style) {
    t10 = {
      margin: "1em 0",
      ...rootStyleProps.style,
      ...rest.style
    };
    $[26] = rest.style;
    $[27] = rootStyleProps.style;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="x1rg5ohu xvgvpxu x15ku74s">Seed:</span>;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== value.seed) {
    t12 = base58.encode(new TextEncoder().encode(`${value.seed}`));
    $[30] = value.seed;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ev => {
      const v = ev.clipboardData.getData("text/plain");
      setValue({
        settled: true,
        seed: +new TextDecoder().decode(base58.decode(v))
      });
    };
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12) {
    t14 = <div className="x78zum5 x6s0dn4 xqtkp2c xu0aao5 x1n2onr6 x1d0dlzq x1tcdsnd xhkezso x1j6awrg x1s928wv xarstr8 x2q1x1w x5hscyn x86avzo x1mbvx0 x2l4bqv xhqgf4x x1o0ppuw">{t11}<input data-timvir-b-arbitrary-seed={true} className="xc342km x1a2a7pz xln7xf2 xjbqb8w xkh2ocl x1717udv xh8yej3 x1heor9g" placeholder="Seed" value={t12} readOnly={true} onPaste={t13} onFocus={_temp} /></div>;
    $[33] = t12;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <button type="button" className="x1a2a7pz xu0aao5 xmkeg23 x1y0btm7 xj7gikm x1cum3z5 x1d0dlzq x1cdhzux xln7xf2 x49kzi4 x1dc5b4e x13m658e x1bx2y69" onClick={refreshSeed}>Refresh</button>;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t14) {
    t16 = <div className="xrvj5dj xd3ue5d x9flyx0 x1e56ztr">{t14}{t15}</div>;
    $[36] = t14;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      margin: 0
    };
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== ExhibitProps || $[40] !== children) {
    t18 = <Exhibit {...ExhibitProps} style={t17}>{children}</Exhibit>;
    $[39] = ExhibitProps;
    $[40] = children;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== T0 || $[43] !== t10 || $[44] !== t16 || $[45] !== t18 || $[46] !== t5 || $[47] !== t6 || $[48] !== t7 || $[49] !== t8) {
    t19 = <T0 data-timvir-b-arbitrary={t5} {...t6} {...t7} className={t8} style={t10}>{t16}{t18}</T0>;
    $[42] = T0;
    $[43] = t10;
    $[44] = t16;
    $[45] = t18;
    $[46] = t5;
    $[47] = t6;
    $[48] = t7;
    $[49] = t8;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== T1 || $[52] !== t19 || $[53] !== t9) {
    t20 = <T1 value={t9}>{t19}</T1>;
    $[51] = T1;
    $[52] = t19;
    $[53] = t9;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  return t20;
}
function _temp(ev_0) {
  ev_0.currentTarget.select();
}
const styles = {
  root: {
    kogj98: "x9t3ola",
    $$css: true
  }
};